import { render } from "./CairoQuran.vue?vue&type=template&id=37d53f40&ts=true"
import script from "./CairoQuran.vue?vue&type=script&lang=ts"
export * from "./CairoQuran.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__